// import styled, { css } from 'styled-components';
// import { darken } from 'polished';

// /** Paleta base */
// const COLORS = {
//   text: '#1f2937', // cinza-900
//   subtext: '#374151', // cinza-700
//   muted: '#6b7280', // cinza-500
//   border: '#e5e7eb', // cinza-200
//   borderSoft: '#cbd0d8', // original
//   cardBg: '#ffffff',
//   rowBg: '#f9fafb', // cinza-50
//   rowBgAlt: '#f3f4f6', // cinza-100
//   primary: '#2c405a',
//   accent: '#ff5a22',
//   danger: '#de3b3b',
//   sismaBg: '#fff7ed', // já usado
// };

// export const Wrapper = styled.div`
//   /* max-width: 950px; */
//   width: 100%;
//   margin: 0 auto;
//   padding: 4px;
// `;

// Wrapper.NotFound = styled.span`
//   display: block;
//   width: 100%;
//   text-align: center;

//   font-size: 14px;
//   font-style: italic;
//   color: rgba(44, 64, 90, 0.5);
//   padding: 40px 0;
// `;

// export const Action = styled.div`
//   align-self: center;

//   > button {
//     background: none;
//     border: 0;
//     color: ${COLORS.primary};
//     transition: color 0.2s ease, transform 0.1s ease;

//     + button {
//       margin-left: 10px;
//     }

//     :hover {
//       color: ${darken(0.05, COLORS.primary)};
//       transform: translateY(-1px);
//     }

//     :focus-visible {
//       outline: 2px solid ${COLORS.accent};
//       outline-offset: 2px;
//       border-radius: 6px;
//     }
//   }
// `;

// export const Table = styled.table`
//   width: 100%;
//   border-collapse: separate;
//   border-spacing: 0 16px;
//   font-size: 12px;
//   color: ${COLORS.text};
//   padding: 6px 0;

//   > tbody > tr > td {
//     text-align: left;
//     vertical-align: top;
//     background: ${COLORS.cardBg};
//     color: ${COLORS.text};
//     /* border: 1px solid ${COLORS.border}; */
//     border-radius: 10px;
//     box-shadow: 0 1px 1px rgba(0, 0, 0, 0.02), 0 4px 10px rgba(0, 0, 0, 0.04);
//     transition: box-shadow 0.2s ease, border-color 0.2s ease,
//       transform 0.05s ease;
//     position: relative;
//     overflow: hidden;
//   }

//   > tbody > tr > td:hover {
//     box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.06),
//       0 10px 20px rgba(0, 0, 0, 0.06);
//   }

//   > tfoot > tr {
//     display: flex;

//     > td {
//       flex: 1;

//       > button {
//         border: 1px solid ${COLORS.border};
//         background: ${COLORS.cardBg};
//         border-radius: 8px;
//         color: ${COLORS.primary};
//         height: 40px;
//         width: 100%;
//         transition: 0.15s all ease;

//         :hover {
//           color: #fff;
//           background: ${COLORS.accent};
//           border-color: ${COLORS.accent};
//         }

//         :focus-visible {
//           outline: 2px solid ${COLORS.accent};
//           outline-offset: 2px;
//         }
//       }
//     }
//   }
// `;

// /** Destaque lateral (status) */
// Table.Container = styled.tr`
//   > td {
//     /* barra lateral de 4px para guiar o olhar */
//     &:before {
//       content: '';
//       position: absolute;
//       left: 0;
//       top: 0;
//       bottom: 0;
//       width: 4px;
//       background: ${COLORS.primary};
//       opacity: 0.6;
//     }

//     ${(props) =>
//       props.cancelled &&
//       css`
//         border-color: ${COLORS.danger} !important;

//         &:before {
//           background: ${COLORS.danger};
//           opacity: 0.9;
//         }
//       `}
//   }
// `;

// Table.Wrapper = styled.div`
//   position: relative;
//   display: flex;
//   flex-direction: column;
//   gap: 0;

//   strong {
//     font-size: 12px;
//     text-transform: uppercase;
//     letter-spacing: 0.02em;
//     color: ${COLORS.muted};
//   }

//   span {
//     font-size: 12px;
//     color: ${COLORS.text};

//     + span {
//       margin-top: 4px;
//     }
//   }
// `;

// /** Cabeçalho “tabelado” com grid e melhor contraste */
// Table.Header = styled.header`
//   padding: 6px 10px;
//   border-top-left-radius: 10px;
//   border-top-right-radius: 10px;
//   border-bottom: 1px solid ${COLORS.border};
//   /* display: grid;
//   grid-template-columns: auto repeat(5, minmax(0, 1fr)) auto auto;
//   gap: 12px 16px; */
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   background: ${COLORS.rowBg};

//   button {
//     background: none;
//     border: 0;
//     color: ${COLORS.muted};
//     transition: color 0.15s ease, transform 0.1s ease;

//     & + button {
//       margin-left: 8px;
//     }

//     :hover {
//       color: ${COLORS.text};
//       transform: translateY(-1px);
//     }

//     :focus-visible {
//       outline: 2px solid ${COLORS.accent};
//       outline-offset: 2px;
//       border-radius: 6px;
//     }
//   }

//   ${(props) =>
//     props.sisma &&
//     css`
//       background-color: ${COLORS.sismaBg};
//       border-bottom-color: #fdba74; /* laranja-300 */
//     `}

//   @media (max-width: 920px) {
//     grid-template-columns: auto repeat(3, minmax(0, 1fr)) auto;
//   }
//   @media (max-width: 640px) {
//     grid-template-columns: auto 1fr;
//   }
// `;

// Table.Header.BtnPrint = styled.button`
//   :hover {
//     color: ${COLORS.primary};
//   }
// `;

// Table.Header.BtnCancel = styled.button`
//   :hover {
//     color: ${COLORS.danger};
//   }
// `;

// /** Corpo como “tabela” compacta com divisórias entre linhas */
// Table.Content = styled.table`
//   width: 100%;
//   padding: 10px 20px;

//   > tbody > tr > td {
//     padding: 8px 0;
//   }

//   > tbody > tr + tr > td {
//     border-top: 1px dashed ${COLORS.border};
//   }
// `;

// Table.Row = styled.div`
//   display: flex;
//   padding: 6px 10px;
//   gap: 12px;
//   align-items: flex-start;

//   button {
//     background: none;
//     border: 0;
//     color: ${COLORS.muted};
//     transition: color 0.15s ease, transform 0.1s ease;

//     :hover {
//       color: ${COLORS.danger};
//       transform: translateY(-1px);
//     }

//     :focus-visible {
//       outline: 2px solid ${COLORS.accent};
//       outline-offset: 2px;
//       border-radius: 6px;
//     }
//   }

//   ${(props) =>
//     props.withBackground &&
//     css`
//       background: ${COLORS.rowBgAlt};
//       border: 1px solid ${COLORS.border};
//       border-radius: 8px;
//       padding: 8px 12px;
//     `}

//   ${(props) =>
//     props.withFlex &&
//     css`
//       flex: 1;
//     `}

//   ${(props) =>
//     props.withCenter &&
//     css`
//       align-items: center;
//       justify-content: center;
//       text-align: center;
//     `}
// `;

// Table.Row.Cancel = styled.span`
//   display: inline-block;
//   color: ${COLORS.danger};
//   background: #fee2e2; /* vermelho-100 */
//   border: 1px solid #fecaca; /* vermelho-200 */
//   font-weight: 600;
//   font-style: italic;
//   padding: 6px 10px;
//   border-radius: 999px;
//   line-height: 1.2;
// `;

// Table.Row.BtnCancel = styled.button`
//   :hover {
//     color: ${COLORS.danger};
//   }
// `;

// Table.Icon = styled.div`
//   padding: 4px 10px 4px 0;
//   display: flex;
//   align-items: center;
// `;

// Table.Col = styled.div`
//   flex: 1;
//   display: flex;
//   flex-direction: column;
//   gap: 1px;
//   min-width: 0; /* evita quebra inesperada */
//   padding: 4px 0 8px;

//   span {
//     white-space: pre-line;
//   }

//   @media (max-width: 640px) {
//     gap: 4px;
//   }
// `;

// // --- ADIÇÕES PARA O MODO TABELA "FLAT" ---

// export const DataTableWrap = styled.div`
//   margin-top: 8px;
//   border: 1px solid #e5e7eb;
//   border-radius: 10px;
//   overflow: auto; /* permite scroll horizontal em telas menores */
//   background: #fff;
// `;

// export const DataTable = styled.table`
//   width: 100%;
//   min-width: 1200px; /* garante legibilidade; ajuste se quiser */
//   border-collapse: separate;
//   border-spacing: 0;
//   font-size: 13px;
//   color: #1f2937;

//   thead th {
//     position: sticky;
//     top: 0;
//     z-index: 1;
//     background: #f9fafb;
//     color: #6b7280;
//     text-transform: uppercase;
//     letter-spacing: 0.03em;
//     font-weight: 700;
//     font-size: 12px;
//     padding: 10px 12px;
//     border-bottom: 1px solid #e5e7eb;
//     white-space: nowrap;
//   }

//   tbody td {
//     padding: 10px 12px;
//     border-bottom: 1px solid #f1f5f9;
//     vertical-align: top;
//     word-break: break-word;
//   }

//   tbody tr:nth-child(even) {
//     background: #fafafa;
//   }

//   tbody tr:hover {
//     background: #f5f7fa;
//   }

//   /* colunas um pouco mais estreitas */
//   td.col--sm,
//   th.col--sm {
//     /* min-width: 60px; */
//     max-width: 50px;
//   }
//   td.col--md,
//   th.col--md {
//     /* min-width: 120px; */
//     max-width: 110px;
//   }
//   td.col--lg,
//   th.col--lg {
//     /* min-width: 200px; */
//     max-width: 190px;
//   }
//   td.col--xl,
//   th.col--xl {
//     /* min-width: 300px; */
//     max-width: 290px;
//   }
// `;

// export const InlineBtn = styled.button`
//   background: none;
//   border: 1px solid #e5e7eb;
//   border-radius: 6px;
//   padding: 4px 6px;
//   line-height: 0;
//   display: inline-flex;
//   align-items: center;
//   justify-content: center;
//   color: #374151;
//   transition: 0.15s all ease;
//   cursor: pointer;

//   &:hover {
//     background: #eef2f7;
//     border-color: #cfd6de;
//   }

//   ${(p) =>
//     p.danger &&
//     css`
//       color: #de3b3b;
//       &:hover {
//         background: #fee2e2;
//         border-color: #fecaca;
//       }
//     `}

//   &:focus-visible {
//     outline: 2px solid #ff5a22;
//     outline-offset: 2px;
//   }
// `;

// export const ActionsCell = styled.div`
//   display: flex;
//   gap: 8px;
//   flex-wrap: wrap;
//   align-items: center;
// `;

// export const IconCell = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 8px;
// `;

// export const Tag = styled.span`
//   display: inline-block;
//   font-size: 11px;
//   font-weight: 600;
//   padding: 2px 8px;
//   border-radius: 999px;
//   background: #e5e7eb;
//   color: #374151;

//   ${(p) =>
//     p.sisma &&
//     css`
//       background: #fff7ed;
//       color: #9a3412;
//       border: 1px solid #fdba74;
//     `}
// `;

// export const StatusPill = styled.span`
//   display: inline-block;
//   font-size: 12px;
//   font-weight: 600;
//   font-style: italic;
//   padding: 4px 8px;
//   border-radius: 999px;
//   background: #e5e7eb;
//   color: #374151;

//   ${(p) =>
//     p.danger &&
//     css`
//       background: #fee2e2;
//       border: 1px solid #fecaca;
//       color: #b91c1c;
//     `}
// `;

// export const LoadMore = styled.div`
//   margin-top: 12px;
//   display: flex;

//   > button {
//     flex: 1;
//     border: 1px solid #e5e7eb;
//     background: #ffffff;
//     border-radius: 8px;
//     color: #2c405a;
//     height: 40px;
//     transition: 0.15s all ease;

//     :hover {
//       color: #fff;
//       background: #ff5a22;
//       border-color: #ff5a22;
//     }

//     :focus-visible {
//       outline: 2px solid #ff5a22;
//       outline-offset: 2px;
//     }
//   }
// `;

// // --- TABELA DOS ITENS DENTRO DE CADA SOLICITAÇÃO ---
// // import styled, { css } from 'styled-components';

// export const ItemsTableWrap = styled.div`
//   border: 1px solid #e5e7eb;
//   border-radius: 8px;
//   overflow: auto; /* scroll horizontal se precisar */
//   background: #ffffff;
// `;

// export const ItemsTable = styled.table`
//   width: 100%;
//   min-width: 900px;
//   border-collapse: separate;
//   border-spacing: 0;
//   font-size: 13px;
//   color: #1f2937;

//   thead th {
//     position: sticky;
//     top: 0;
//     z-index: 1;
//     background: #f9fafb;
//     color: #6b7280;
//     text-transform: uppercase;
//     letter-spacing: 0.03em;
//     font-weight: 700;
//     font-size: 12px;
//     padding: 10px 12px;
//     border-bottom: 1px solid #e5e7eb;
//     white-space: nowrap;
//   }

//   tbody td {
//     padding: 10px 12px;
//     border-bottom: 1px solid #f1f5f9;
//     vertical-align: top;
//     word-break: break-word;
//   }

//   tbody tr:nth-child(even) {
//     background: #fafafa;
//   }

//   tbody tr:hover {
//     background: #f5f7fa;
//   }

//   /* larguras úteis */
//   td.col--sm,
//   th.col--sm {
//     min-width: 90px;
//   }
//   td.col--md,
//   th.col--md {
//     min-width: 140px;
//   }
//   td.col--lg,
//   th.col--lg {
//     min-width: 220px;
//   }
// `;

// export const ItemsActions = styled.div`
//   display: flex;
//   gap: 8px;
//   flex-wrap: wrap;
//   align-items: center;
// `;

// export const ItemsInlineBtn = styled.button`
//   background: none;
//   border: 1px solid #e5e7eb;
//   border-radius: 6px;
//   padding: 4px 6px;
//   line-height: 0;
//   display: inline-flex;
//   align-items: center;
//   justify-content: center;
//   color: #374151;
//   transition: 0.15s all ease;
//   cursor: pointer;

//   &:hover {
//     background: #eef2f7;
//     border-color: #cfd6de;
//   }

//   ${(p) =>
//     p.danger &&
//     css`
//       color: #de3b3b;
//       &:hover {
//         background: #fee2e2;
//         border-color: #fecaca;
//       }
//     `}

//   &:focus-visible {
//     outline: 2px solid #ff5a22;
//     outline-offset: 2px;
//   }
// `;

// export const ItemsStatusPill = styled.span`
//   display: inline-block;
//   font-size: 12px;
//   font-weight: 600;
//   font-style: italic;
//   padding: 4px 8px;
//   border-radius: 999px;
//   background: #e5e7eb;
//   color: #374151;

//   ${(p) =>
//     p.danger &&
//     css`
//       background: #fee2e2;
//       border: 1px solid #fecaca;
//       color: #b91c1c;
//     `}
// `;

import styled, { css } from 'styled-components';
import { darken } from 'polished';

/** Paleta base */
const COLORS = {
  text: '#1f2937', // cinza-900
  subtext: '#374151', // cinza-700
  muted: '#6b7280', // cinza-500
  border: '#e5e7eb', // cinza-200
  borderSoft: '#cbd0d8', // original
  cardBg: '#ffffff',
  rowBg: '#f9fafb', // cinza-50
  rowBgAlt: '#f3f4f6', // cinza-100
  primary: '#2c405a',
  accent: '#ff6d3c',
  danger: '#de3b3b',
  sismaBg: '#fff7ed', // já usado
};

/** Gradiente primário da marca (alinhado ao login / Header) */
const PRIMARY_GRADIENT =
  'linear-gradient(135deg, #ff6d3c 0%, #ff875f 52%, #ff9b78 100%)';

export const Wrapper = styled.div`
  /* max-width: 950px; */
  width: 100%;
  margin: 0 auto;
  padding: 4px;
`;

Wrapper.NotFound = styled.span`
  display: block;
  width: 100%;
  text-align: center;

  font-size: 14px;
  font-style: italic;
  color: rgba(44, 64, 90, 0.5);
  padding: 40px 0;
`;

export const Action = styled.div`
  align-self: center;

  > button {
    background: none;
    border: 0;
    color: ${COLORS.primary};
    transition: color 0.2s ease, transform 0.1s ease;

    + button {
      margin-left: 10px;
    }

    :hover {
      color: ${darken(0.05, COLORS.primary)};
      transform: translateY(-1px);
    }

    :focus-visible {
      outline: 2px solid ${COLORS.accent};
      outline-offset: 2px;
      border-radius: 6px;
    }
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 16px;
  font-size: 12px;
  color: ${COLORS.text};
  padding: 6px 0;

  > tbody > tr > td {
    text-align: left;
    vertical-align: top;
    background: ${COLORS.cardBg};
    color: ${COLORS.text};
    /* border: 1px solid ${COLORS.border}; */
    border-radius: 10px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.02), 0 4px 10px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.2s ease, border-color 0.2s ease,
      transform 0.05s ease;
    position: relative;
    overflow: hidden;
  }

  > tbody > tr > td:hover {
    box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.06),
      0 10px 20px rgba(0, 0, 0, 0.06);
  }

  > tfoot > tr {
    display: flex;

    > td {
      flex: 1;

      > button {
        border: 1px solid ${COLORS.border};
        background: ${COLORS.cardBg};
        border-radius: 10px;
        color: ${COLORS.primary};
        font-weight: 700;
        height: 40px;
        width: 100%;
        cursor: pointer;
        transition: color 0.2s ease, background 0.2s ease,
          border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

        :hover {
          color: #fff;
          background: ${PRIMARY_GRADIENT};
          border-color: transparent;
          box-shadow: 0 12px 26px rgba(255, 109, 60, 0.3);
          transform: translateY(-1px);
        }

        :focus-visible {
          outline: 2px solid ${COLORS.accent};
          outline-offset: 2px;
        }
      }
    }
  }
`;

/** Destaque lateral (status) */
Table.Container = styled.tr`
  > td {
    /* barra lateral de 4px para guiar o olhar */
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background: ${COLORS.primary};
      opacity: 0.6;
    }

    ${(props) =>
      props.cancelled &&
      css`
        border-color: ${COLORS.danger} !important;

        &:before {
          background: ${COLORS.danger};
          opacity: 0.9;
        }
      `}
  }
`;

Table.Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0;

  strong {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    color: ${COLORS.muted};
  }

  span {
    font-size: 12px;
    color: ${COLORS.text};

    + span {
      margin-top: 4px;
    }
  }
`;

/** Cabeçalho “tabelado” com grid e melhor contraste */
Table.Header = styled.header`
  padding: 6px 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: 1px solid ${COLORS.border};
  /* display: grid;
  grid-template-columns: auto repeat(5, minmax(0, 1fr)) auto auto;
  gap: 12px 16px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${COLORS.rowBg};

  button {
    background: none;
    border: 0;
    color: ${COLORS.muted};
    transition: color 0.15s ease, transform 0.1s ease;

    & + button {
      margin-left: 8px;
    }

    :hover {
      color: ${COLORS.text};
      transform: translateY(-1px);
    }

    :focus-visible {
      outline: 2px solid ${COLORS.accent};
      outline-offset: 2px;
      border-radius: 6px;
    }
  }

  ${(props) =>
    props.sisma &&
    css`
      background-color: ${COLORS.sismaBg};
      border-bottom-color: #fdba74; /* laranja-300 */
    `}

  @media (max-width: 920px) {
    grid-template-columns: auto repeat(3, minmax(0, 1fr)) auto;
  }
  @media (max-width: 640px) {
    grid-template-columns: auto 1fr;
  }
`;

Table.Header.BtnPrint = styled.button`
  :hover {
    color: ${COLORS.primary};
  }
`;

Table.Header.BtnCancel = styled.button`
  :hover {
    color: ${COLORS.danger};
  }
`;

/** Corpo como “tabela” compacta com divisórias entre linhas */
Table.Content = styled.table`
  width: 100%;
  padding: 10px 20px;

  > tbody > tr > td {
    padding: 8px 0;
  }

  > tbody > tr + tr > td {
    border-top: 1px dashed ${COLORS.border};
  }
`;

Table.Row = styled.div`
  display: flex;
  padding: 6px 10px;
  gap: 12px;
  align-items: flex-start;

  button {
    background: none;
    border: 0;
    color: ${COLORS.muted};
    transition: color 0.15s ease, transform 0.1s ease;

    :hover {
      color: ${COLORS.danger};
      transform: translateY(-1px);
    }

    :focus-visible {
      outline: 2px solid ${COLORS.accent};
      outline-offset: 2px;
      border-radius: 6px;
    }
  }

  ${(props) =>
    props.withBackground &&
    css`
      background: ${COLORS.rowBgAlt};
      border: 1px solid ${COLORS.border};
      border-radius: 8px;
      padding: 8px 12px;
    `}

  ${(props) =>
    props.withFlex &&
    css`
      flex: 1;
    `}

  ${(props) =>
    props.withCenter &&
    css`
      align-items: center;
      justify-content: center;
      text-align: center;
    `}
`;

Table.Row.Cancel = styled.span`
  display: inline-block;
  color: ${COLORS.danger};
  background: #fee2e2; /* vermelho-100 */
  border: 1px solid #fecaca; /* vermelho-200 */
  font-weight: 600;
  font-style: italic;
  padding: 6px 10px;
  border-radius: 999px;
  line-height: 1.2;
`;

Table.Row.BtnCancel = styled.button`
  :hover {
    color: ${COLORS.danger};
  }
`;

Table.Icon = styled.div`
  padding: 4px 10px 4px 0;
  display: flex;
  align-items: center;
`;

Table.Col = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0; /* evita quebra inesperada */
  padding: 4px 0 8px;

  span {
    white-space: pre-line;
  }

  @media (max-width: 640px) {
    gap: 4px;
  }
`;

// --- ADIÇÕES PARA O MODO TABELA "FLAT" ---

export const DataTableWrap = styled.div`
  margin-top: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: auto; /* permite scroll horizontal em telas menores */
  background: #fff;
`;

export const DataTable = styled.table`
  width: 100%;
  min-width: 1200px; /* garante legibilidade; ajuste se quiser */
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;
  color: #1f2937;

  thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #f9fafb;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    font-weight: 700;
    font-size: 12px;
    padding: 10px 12px;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
  }

  tbody td {
    padding: 10px 12px;
    border-bottom: 1px solid #f1f5f9;
    vertical-align: top;
    word-break: break-word;
  }

  tbody tr:nth-child(even) {
    background: #fafafa;
  }

  tbody tr:hover {
    background: #f5f7fa;
  }

  /* colunas um pouco mais estreitas */
  td.col--sm,
  th.col--sm {
    /* min-width: 60px; */
    max-width: 50px;
  }
  td.col--md,
  th.col--md {
    /* min-width: 120px; */
    max-width: 110px;
  }
  td.col--lg,
  th.col--lg {
    /* min-width: 200px; */
    max-width: 190px;
  }
  td.col--xl,
  th.col--xl {
    /* min-width: 300px; */
    max-width: 290px;
  }
`;

export const InlineBtn = styled.button`
  background: none;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 4px 6px;
  line-height: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #374151;
  transition: 0.15s all ease;
  cursor: pointer;

  &:hover {
    background: #eef2f7;
    border-color: #cfd6de;
  }

  ${(p) =>
    p.danger &&
    css`
      color: #de3b3b;
      &:hover {
        background: #fee2e2;
        border-color: #fecaca;
      }
    `}

  &:focus-visible {
    outline: 2px solid #ff6d3c;
    outline-offset: 2px;
  }
`;

export const ActionsCell = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
`;

export const IconCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Tag = styled.span`
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 999px;
  background: #e5e7eb;
  color: #374151;

  ${(p) =>
    p.sisma &&
    css`
      background: #fff7ed;
      color: #9a3412;
      border: 1px solid #fdba74;
    `}
`;

export const StatusPill = styled.span`
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  font-style: italic;
  padding: 4px 8px;
  border-radius: 999px;
  background: #e5e7eb;
  color: #374151;

  ${(p) =>
    p.danger &&
    css`
      background: #fee2e2;
      border: 1px solid #fecaca;
      color: #b91c1c;
    `}
`;

export const LoadMore = styled.div`
  margin-top: 12px;
  display: flex;

  > button {
    flex: 1;
    border: 1px solid #e5e7eb;
    background: #ffffff;
    border-radius: 10px;
    color: #2c405a;
    font-weight: 700;
    height: 40px;
    cursor: pointer;
    transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease,
      box-shadow 0.2s ease, transform 0.2s ease;

    :hover {
      color: #fff;
      background: ${PRIMARY_GRADIENT};
      border-color: transparent;
      box-shadow: 0 12px 26px rgba(255, 109, 60, 0.3);
      transform: translateY(-1px);
    }

    :focus-visible {
      outline: 2px solid #ff6d3c;
      outline-offset: 2px;
    }
  }
`;

// --- TABELA DOS ITENS DENTRO DE CADA SOLICITAÇÃO ---
// import styled, { css } from 'styled-components';

export const ItemsTableWrap = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: auto; /* scroll horizontal se precisar */
  background: #ffffff;
`;

export const ItemsTable = styled.table`
  width: 100%;
  min-width: 900px;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;
  color: #1f2937;

  thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #f9fafb;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    font-weight: 700;
    font-size: 12px;
    padding: 10px 12px;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
  }

  tbody td {
    padding: 10px 12px;
    border-bottom: 1px solid #f1f5f9;
    vertical-align: top;
    word-break: break-word;
  }

  tbody tr:nth-child(even) {
    background: #fafafa;
  }

  tbody tr:hover {
    background: #f5f7fa;
  }

  /* larguras úteis */
  td.col--sm,
  th.col--sm {
    min-width: 90px;
  }
  td.col--md,
  th.col--md {
    min-width: 140px;
  }
  td.col--lg,
  th.col--lg {
    min-width: 220px;
  }
`;

export const ItemsActions = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
`;

export const ItemsInlineBtn = styled.button`
  background: none;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 4px 6px;
  line-height: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #374151;
  transition: 0.15s all ease;
  cursor: pointer;

  &:hover {
    background: #eef2f7;
    border-color: #cfd6de;
  }

  ${(p) =>
    p.danger &&
    css`
      color: #de3b3b;
      &:hover {
        background: #fee2e2;
        border-color: #fecaca;
      }
    `}

  &:focus-visible {
    outline: 2px solid #ff6d3c;
    outline-offset: 2px;
  }
`;

export const ItemsStatusPill = styled.span`
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  font-style: italic;
  padding: 4px 8px;
  border-radius: 999px;
  background: #e5e7eb;
  color: #374151;

  ${(p) =>
    p.danger &&
    css`
      background: #fee2e2;
      border: 1px solid #fecaca;
      color: #b91c1c;
    `}
`;
